import React from 'react'

export default function StoreAdvanced() {

  return (
    <>
      <section>
        <h4 className="settingstitle">Software</h4>
        <div className="infocont">
          <div><p>Theme</p><span>Amplify Commerce &trade;</span></div>
          <div><p>Version</p><span>2.3.0</span></div>
          <div><p>Author Site</p><span>Atomics Digital</span></div>
          <div><p>Author URL</p><span><a href="https://atomicsdigital.com" target="_blank" rel="noreferrer">www.atomicsdigital.com</a></span></div>
          <div><p>Last Update</p><span>August 05 2021</span></div>
        </div>
      </section>
      <section>
        <h4 className="settingstitle">Integrations</h4>
        <ul>

        </ul>
      </section>
      <section>
        <h4 className="settingstitle">Custom Page Design</h4>
        <small><i className="far fa-rocket-launch"></i> Coming soon</small>
      </section>
    </>
  )
}